type BillingHistoryItem = {
  date: string
  amount: number
  status: 'paid' | 'pending' | 'failed'
}

type BillingHistoryProps = {
  data: BillingHistoryItem[]
}

export function BillingHistory({ data }: BillingHistoryProps) {
  return (
    <div className="mt-stack-roomy space-y-stack-roomy">
      {data.map((item) => (
        <div
          key={item.date}
          className="flex justify-between items-center"
        >
          <div>
            <div className="font-medium">{item.date}</div>
            <div className="text-body-sm text-fg-subtle">${item.amount.toFixed(2)}</div>
          </div>
          <div className="flex items-center space-x-stack">
            <span className="text-body-sm text-fg-muted">{item.status}</span>
            <button className="text-fg-subtle hover:text-fg-muted">
              <svg
                className="w-5 h-5"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                />
              </svg>
            </button>
          </div>
        </div>
      ))}
    </div>
  )
}
